import {
   Box,
   Button,
   Chip,
   FormControl,
   Grid,
   InputAdornment,
   InputLabel,
   MenuItem,
   Select,
   TextField,
   Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React, { useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { colors, sizes } from "../../setupUtils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
   getCGDetail,
   getCGForCountry,
   getCGRefData,
   setCGState,
} from "../customerGroupSetupSlice";
import Status from "./Status";
import CollapseSection from "../../../../components/ui/CollapseSection";

export default function SearchCG() {
   const cgState = useSelector((store) => store.customerGroupSetup);
   const {
      countries,
      country,
      countryID,
      editFromDate,
      editToDate,
      customerTypes,
      customerType,
      customerTypeCode,
      customerGroups,
      customerGroupName,
      customerGroupID,
      editCGName,
      customerGroupDetail,
      status,
      customers,
      selCustomers,
      customerLevels,
   } = cgState;
   const dispatch = useDispatch();

   useEffect(() => {
      if (country !== "" && customerTypeCode !== "") {
         dispatch(
            getCGForCountry({ countryID, customerTypeCode, customerGroupName })
         );
      }
   }, [country, customerTypeCode]);

   const minDate = dayjs().add(1, "day");

   useEffect(() => {
      if (
         customerGroupDetail !== null &&
         Object.keys(customerGroupDetail).length > 0
      ) {
         setCGDetails();
      }
   }, [customerGroupDetail]);

   function showPopup(message, severity) {
      dispatch(setCGState("popUpMsg", message));
      dispatch(setCGState("popUpSeverity", severity));
      dispatch(setCGState("popUpOpen", true));
   }

   function updateCountry(event) {
      const countryName = event.target.value;
      const countryID = countries.find(
         (country) => country.countryName === countryName
      ).countryID;
      dispatch(setCGState("country", countryName));
      dispatch(setCGState("countryID", countryID));
      //reset states because of country change
      resetStatesOnCountryChange();

      dispatch(getCGRefData({ countryID }));
   }

   function resetStatesOnCountryChange() {
      dispatch(setCGState("is_refresh", true));
      dispatch(setCGState("customerGroupName", ""));
      dispatch(setCGState("customerType", ""));
      dispatch(setCGState("customerTypeCode", ""));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editCGName", ""));
      dispatch(setCGState("editFromDate", dayjs().add(1, "day")));
      dispatch(setCGState("editToDate", dayjs("2099-12-31T00:00:00.000Z")));
      dispatch(setCGState("status", "None"));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editComments", ""));
      dispatch(setCGState("customerLevel", ""));
      dispatch(setCGState("customerLevelID", ""));
      dispatch(setCGState("files", []));
   }

   function updateCustomerType(event) {
      const type = event.target.value;
      const typeCode = customerTypes.find(
         (cType) => cType.customerTypeName === type
      ).customerTypeCode;
      dispatch(setCGState("customerType", type));
      dispatch(setCGState("customerTypeCode", typeCode));

      //reset states because of type change
      resetStatesOnTypeChange();
   }

   function resetStatesOnTypeChange() {
      dispatch(setCGState("is_refresh", true));
      dispatch(setCGState("customerGroupName", ""));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editCGName", ""));
      dispatch(setCGState("editFromDate", dayjs().add(1, "day")));
      dispatch(setCGState("editToDate", dayjs("2099-12-31T00:00:00.000Z")));
      dispatch(setCGState("status", "None"));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editComments", ""));
      dispatch(setCGState("customerLevel", ""));
      dispatch(setCGState("customerLevelID", ""));
      dispatch(setCGState("files", []));
   }

   function resetStatesOnCGChange() {
      dispatch(setCGState("is_refresh", true));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editCGName", ""));
      dispatch(setCGState("editFromDate", dayjs().add(1, "day")));
      dispatch(setCGState("editToDate", dayjs("2099-12-31T00:00:00.000Z")));
      dispatch(setCGState("status", "None"));
      dispatch(setCGState("customers", []));
      dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("editComments", ""));
      dispatch(setCGState("customerLevel", ""));
      dispatch(setCGState("customerLevelID", ""));
      dispatch(setCGState("files", []));
   }

   function updateCGName(event) {
      const name = event.target.value;
      const id = customerGroups.find(
         (group) => group.customerGroupName === name
      ).customerGroupID;
      dispatch(setCGState("customerGroupName", name));
      dispatch(setCGState("customerGroupID", id));
      dispatch(setCGState("is_refresh", true));
      resetStatesOnCGChange();
   }

   function getCGDetails() {
      dispatch(setCGState("is_refresh", true));
      if (country === "") {
         showPopup("Please select a country.", "info");
         return;
      }
      if (customerType === "") {
         showPopup("Please select a type.", "info");
         return;
      }
      if (customerGroupName === "") {
         showPopup("Please select a a customer group.", "info");
         return;
      }
      dispatch(getCGDetail({ customerGroupID }));
   }

   function setCGDetails() {
      if (customerGroupDetail !== null) {
         const {
            customerGroupName,
            effectiveStartDate,
            effectiveEndDate,
            status,
            customerlist,
            comments,
            customerGroupLevelCode,
            customerGroupFiles,
         } = customerGroupDetail;
         const startDateDayjs = dayjs(effectiveStartDate);
         const endDateDayjs = dayjs(effectiveEndDate);
         dispatch(setCGState("editCGName", customerGroupName));
         dispatch(setCGState("editFromDate", startDateDayjs));
         dispatch(setCGState("editToDate", endDateDayjs));
         dispatch(setCGState("status", status));
         dispatch(setCGState("customers", []));
         dispatch(setCGState("selCustomers", customerlist));
         dispatch(setCGState("editComments", comments));

         const level = customerLevels.find(
            (item) => item.customerLevelID === customerGroupLevelCode
         ).customerLevel;
         dispatch(setCGState("customerLevel", level));
         dispatch(setCGState("customerLevelID", customerGroupLevelCode));
         dispatch(setCGState("files", customerGroupFiles));
      }
   }

   function updateEditCGName(event) {
      const name = event.target.value;
      dispatch(setCGState("editCGName", name));
   }

   function handleFromDate(newDate) {
      dispatch(setCGState("editFromDate", newDate));
      const selected = selCustomers.map((item) => {
         return {
            ...item,
            effectiveStartDate: newDate,
         };
      });
      dispatch(setCGState("selCustomers", selected));
   }

   function handleToDate(newDate) {
      dispatch(setCGState("editToDate", newDate));
      const selected = selCustomers.map((item) => {
         return {
            ...item,
            effectiveEndDate: newDate,
         };
      });
      dispatch(setCGState("selCustomers", selected));
   }

   return (
      <Box>
         {/* COUNTRY, TYPE, SELECT CUSTOMER GROUP, SEARCH */}
         <Box
            sx={{
               mt: 3,
               maxWidth: "99%",
            }}
         >
            <Grid
               container
               columns={12}
               spacing={2}
               justifyContent={"space-between"}
            >
               <Grid item sm={3} md={3} lg={3}>
                  <FormControl>
                     <InputLabel>Country</InputLabel>
                     <Select
                        value={country}
                        label="Country"
                        sx={{
                           height: sizes.h35,
                           width: sizes.w270,
                           color: colors.black,
                           mt: 1,
                        }}
                        onChange={updateCountry}
                     >
                        {countries.map((country, index) => {
                           return (
                              <MenuItem key={index} value={country.countryName}>
                                 {country.countryName}
                              </MenuItem>
                           );
                        })}
                     </Select>
                  </FormControl>
               </Grid>

               <Grid item md={3} lg={3}>
                  <FormControl>
                     <InputLabel>Type</InputLabel>
                     <Select
                        value={customerType}
                        label="Type"
                        sx={{
                           height: sizes.h35,
                           width: sizes.w270,
                           color: colors.black,
                           mt: 1,
                        }}
                        onChange={updateCustomerType}
                     >
                        {customerTypes.map((type, index) => {
                           return (
                              <MenuItem
                                 key={index}
                                 value={type.customerTypeName}
                              >
                                 {type.customerTypeCode} |{" "}
                                 {type.customerTypeName}
                              </MenuItem>
                           );
                        })}
                     </Select>
                  </FormControl>
               </Grid>

               <Grid item sm={3} md={4} lg={4.7}>
                  <FormControl>
                     <InputLabel>Select Customer Group</InputLabel>
                     <Select
                        value={customerGroupName}
                        label="Select Customer Group"
                        sx={{
                           height: sizes.h35,
                           width: sizes.w270,
                           color: colors.black,
                           mt: 1,
                        }}
                        onChange={updateCGName}
                     >
                        {customerGroups.map((cg, index) => {
                           return (
                              <MenuItem
                                 key={index}
                                 value={cg.customerGroupName}
                              >
                                 {cg.customerGroupName}
                              </MenuItem>
                           );
                        })}
                     </Select>
                  </FormControl>
               </Grid>

               <Grid item sm={3} md={1.5} lg={1.3}>
                  <Button
                     startIcon={<KeyboardArrowRightIcon />}
                     sx={{
                        bgcolor: "#007DC3",
                        color: colors.white,
                        textTransform: "none",
                        "&:hover": {
                           bgcolor: "#007DC3",
                        },
                     }}
                     onClick={getCGDetails}
                  >
                     <Typography
                        sx={{ fontWeight: "bold", color: colors.white }}
                     >
                        Go
                     </Typography>
                  </Button>
               </Grid>
            </Grid>
         </Box>

         {/* CUSTOMER GROUP NAME, VALIDITY PERIOD FROM, VALIDITY PERIOD TO */}
         <Box sx={{ mt: 4, mb: 4, }}>
         {/* <Typography 
         className="compHeading"
        variant="subtitle1"
        sx={{mt: 3,  }}
      >
       Define Customer Group
      </Typography> */}
      		<CollapseSection title="Define Customer Group">
            <Grid
               container
               columns={8}
               spacing={3}
               mt={1}
               alignContent={"space-between"}
            >
               <Grid item sm={6} md={3} lg={2.8}>
                  <TextField
                     disabled
                     label="Customer Group Name"
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position="end">
                              <EditIcon />
                           </InputAdornment>
                        ),
                     }}
                     variant="standard"
                     value={editCGName}
                     onChange={updateEditCGName}
                  />
               </Grid>
               <Grid item sm={6} md={2.5} lg={2}>
                  <Box sx={{ mt: 1 }}>
                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                           disabled
                           label="From"
                           value={editFromDate}
                           onChange={(newDate) => handleFromDate(newDate)}
                           renderInput={(params) => (
                              <TextField
                                 {...params}
                                 size="small"
                                 sx={{ width: sizes.w200 }}
                              />
                           )}
                           format="DD/MM/YYYY"
                        />
                     </LocalizationProvider>
                  </Box>
               </Grid>
               <Grid item sm={6} md={2.5} lg={2}>
                  <Box sx={{ mt: 1 }}>
                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                           minDate={minDate}
                           label="To"
                           value={editToDate}
                           onChange={(newDate) => handleToDate(newDate)}
                           disabled={customerGroupDetail?.isDeactivated == 1 ? true : false}
                           renderInput={(params) => (
                              <TextField
                                 {...params}
                                 size="small"
                                 sx={{ width: sizes.w200 }}
                              />
                           )}
                           format="DD/MM/YYYY"
                        />
                     </LocalizationProvider>
                  </Box>
               </Grid>
               <Grid item sm={6} md={3} lg={1} mt={1}>
                  <Status label={status} />
               </Grid>
            </Grid>
            </CollapseSection>
         </Box>
      </Box>
   );
}
